import { AUTH, DASHBOARD } from "~/constants/routes";
import { DISABLE_AUTH_GUARD } from "~/constants/flags";

export default defineNuxtRouteMiddleware((to) => {
  const auth = useAuthStore();
  const requiresAuth = to.meta.requiresAuth ?? true;

  if (DISABLE_AUTH_GUARD) {
    return;
  }

  if (auth.isAuthenticated && to.path === AUTH.SIGNIN) {
    return navigateTo(DASHBOARD.HOME);
  }

  if (requiresAuth && !auth.isAuthenticated) {
    return navigateTo(AUTH.SIGNIN);
  }
});
